export enum DocumentType {
  CUSTOMER_SIGNATURE = 'CUSTOMER_SIGNATURE',
  CUSTOMER_VEHICLE_PHOTO = 'CUSTOMER_VEHICLE_PHOTO',
  LICENSE_PLATE_PHOTO = 'LICENSE_PLATE_PHOTO',
  RECEIPT = 'RECEIPT',
  OTHER = 'OTHER',
}

export interface CapturedPhoto {
  dataUrl: string
  latitude: number
  longitude: number
  captureTime: string
  documentType: DocumentType
  file?: File
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  [DocumentType.CUSTOMER_SIGNATURE]: 'Customer Signature',
  [DocumentType.CUSTOMER_VEHICLE_PHOTO]: 'Vehicle Photo',
  [DocumentType.LICENSE_PLATE_PHOTO]: 'License Plate',
  [DocumentType.RECEIPT]: 'Receipt',
  [DocumentType.OTHER]: 'Other',
}
